<template>
  <div>
    <Header/>
    <AdsPanel/>
    <DomainPanel/>
    <ProductPanel/>
    <ContactPanel/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import AdsPanel from './components/AdsPanel'
import ProductPanel from './components/ProductPanel'
import Footer from './components/Footer'
import DomainPanel from './components/DomainPanel'
import ContactPanel from './components/ContactPanel'
export default {
  components: {DomainPanel, Footer, ProductPanel, AdsPanel, Header, ContactPanel}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue